module.exports = __webpack_public_path__ + "img/graph.15c76858.svg";